const formatCamelCase = (input = "") => {
  if (!input) return "";
  return input
    .replace(/([a-z])([A-Z])/g, "$1 $2") // insert space before capital letters
    .replace(/^./, (str) => str.toUpperCase()); // capitalize first letter
};

export default formatCamelCase;
